module.exports = __webpack_public_path__ + "media/day/143-263a02ec.svg";